import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const EnergyOrbsAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<8; i++){
    const ang = (i/8) * Math.PI * 2 + progress * 2;
    const dst = e.maxRadius + progress * 100;
    const r = getRadiusAtAngle(ang, e, dst);
    const cx = e.pos.x + Math.cos(ang) * r;
    const cy = e.pos.y + Math.sin(ang) * r;
    ctx.beginPath(); ctx.arc(cx, cy, 12 * (1-progress), 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('ENERGY_ORBS', EnergyOrbsAnimation);
